import { render, staticRenderFns } from "./GasStationEdit.vue?vue&type=template&id=665bf58e&"
import script from "./GasStationEdit.vue?vue&type=script&lang=js&"
export * from "./GasStationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports